module.exports = __webpack_public_path__ + "img/profile-wallet.13e99910.svg";